import React from 'react';
import '../../styles/modals.css';

interface BananaCupInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const BananaCupInfoModal: React.FC<BananaCupInfoModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Banana Cup Rules</h2>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          <h3>How the Banana Cup Works</h3>
          <p>The Banana Cup is a climbing competition system that rewards climbers with the most tasty bananas!</p>

          <h4>🍌 The Banana Formula:</h4>
          <ul>
            <li><strong>Every climbing route starts with 100 bananas</strong> when it's created</li>
            <li><strong>Bananas are shared equally</strong> among all climbers who top the route</li>
            <li><strong>Your bananas = 100 ÷ number of climbers who topped the route</strong></li>
            <li>The more popular a route, the fewer bananas each climber gets! Easier routes are more likely to be topped more often</li>
          </ul>

          <h4>🎯 Qualifying Climbs:</h4>
          <p>Only these performance types count for bananas:</p>
          <ul>
            <li><strong>On-sight</strong> - Topped the route without hangs, from the first time</li>
            <li><strong>Topped</strong> - Topped the route without hangs</li>
          </ul>

          <h4>📊 Strategy Tips:</h4>
          <ul>
            <li><strong>Seek variety:</strong> Climb many different routes rather than repeating the same ones</li>
            <li><strong>Challenge yourself:</strong> All routes give equal base bananas regardless of difficulty</li>
          </ul>

          <h4>⚠️ Hungry Fré:</h4>
          <p style={{ padding: '12px', backgroundColor: '#fff3cd', border: '1px solid #ffeaa7', borderRadius: '6px', margin: '10px 0' }}>
            <strong>Warning:</strong> When a climbing route gets decommissioned or removed, Fré gets hungry and eats all the bananas you earned from that route! 
            Your banana count will be automatically reduced. This encourages climbers to stay active on current routes.
          </p>

          <h4>🏆 Rankings:</h4>
          <p>Rankings are calculated in real-time by summing all your bananas from completed routes. 
          The more routes you complete and the earlier you complete them, the higher your ranking!</p>
        </div>
        <div className="modal-footer">
          <button className="close-modal-button" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default BananaCupInfoModal;
